import "./styles.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { EventsView } from "./views/events/events.view";
import { ScheduleView } from "./views/schedule/schedule.view";
import { CampsView } from "./views/camps/camps.view";
import { RegistrationView } from "./views/registration/registration.view";
import { RegisterView } from "./views/registration/register.view";
import { TryoutView } from "./views/registration/tryout.view";
import { TaggedScheduleView } from "./views/schedule/tagged-schedule.view";
import { PreregisterView } from "./views/registration/preregister.view";

const router = createBrowserRouter([
  {
    path: "/",
    element: <div>Hello there!</div>,
  },
  {
    path: "/events",
    element: <EventsView />,
  },
  {
    path: "/schedule",
    element: <ScheduleView />,
  },
  {
    path: "/tschedule",
    element: <TaggedScheduleView />,
  },
  {
    path: "/camps",
    element: <CampsView />,
  },
  {
    path: "/registration/:eventId",
    element: <RegistrationView />,
  },
  {
    path: "/register/:eventId",
    element: <RegisterView />,
  },
  {
    path: "/preregister/:eventId",
    element: <PreregisterView />,
  },
  {
    path: "/tryout",
    element: <TryoutView />,
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
